import { NgModule } from '@angular/core';
import { TfmatLibComponent } from './tfmat-lib.component';
import { FooComponent } from './foo/foo.component';

@NgModule({
  imports: [
  ],
  declarations: [TfmatLibComponent, FooComponent],
  exports: [TfmatLibComponent,FooComponent]
})
export class TfmatLibModule { }
